import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';


/**
 * 1700. 受注案件契約タスク購読解除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id/sales_order_contract_task_subscriptions/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
};

const destroySalesOrderContractTaskSubscription = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.task_id}/sales_order_contract_task_subscriptions/${props.id}`
  );
};

export const useDestroySalesOrderContractTaskSubscription = () => {
  return useMutation({
    mutationFn: destroySalesOrderContractTaskSubscription
  });
};